import { Stack, Typography } from '@mui/material';
import EmptyBox from '../../../../../assets/images/empty-box-image.svg';

export const HomepageNotificationsEmptyState: React.FC = () => {
  return (
    <Stack 
      gap={1}
      sx={{
        alignItems: 'center',
        pt: 8,
      }}
    >
      <img
        src={EmptyBox}
        alt="Empty notifications"
      />
      <Typography variant='subtitle1'>There are no new notifications</Typography>
      <Typography
        variant='body2'
        color={theme => theme.palette.text.secondary}
      >
        Your notifications will appear here
      </Typography>
    </Stack>
  );
};